export default __webpack_public_path__ + "static/media/Blue.20b61e94.png";